var map = {
	"./address.svg": "25c4",
	"./doc-icon.svg": "f71b",
	"./ic-lb.svg": "a242",
	"./phone.svg": "b470",
	"./settled-close.svg": "d2aa",
	"./side-back.svg": "50be",
	"./side-customer.svg": "6b97",
	"./side-phone.svg": "a7ef",
	"./side-tel.svg": "75b6",
	"./tips.svg": "a994",
	"./zip-icon.svg": "bc70"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";